import { Text } from '@viapeople/components'
import type { FormInputComponent } from '../types'
import { DropZone } from './DropZone'
import { FormComponentWrapper } from './formComponentWrapper/FormComponentWrapper'

export function ComponentsRenderer({
	components,
	containerId,
}: {
	components: FormInputComponent[]
	containerId?: string
}) {
	// Filter out deleted components to ensure correct drop zone indices
	const visibleComponents = components.filter((c) => c.action !== 'delete')

	if (visibleComponents.length === 0) {
		return (
			<div className='flex flex-col gap-4'>
				<DropZone
					id={`${containerId || 'root'}-0`}
					containerId={containerId}
					index={0}
					className='h-20 border-2 border-dashed border-neutral-300 bg-neutral-50'
				/>
				<div className='text-center py-8 text-neutral-500 border-2 border-dashed border-neutral-300 rounded-md'>
					<Text variant='small'>Drop components here to build your form</Text>
				</div>
			</div>
		)
	}

	return (
		<div className='flex flex-col gap-2'>
			<DropZone id={`${containerId || 'root'}-0`} containerId={containerId} index={0} />

			{visibleComponents.map((component, index) => (
				<div key={component.id} className='flex flex-col gap-2'>
					<FormComponentWrapper component={component} index={index} />
					<DropZone id={`${containerId || 'root'}-${index + 1}`} containerId={containerId} index={index + 1} />
				</div>
			))}
		</div>
	)
}
